import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@/contexts/ThemeContext';

export const V11ThemeToggle = () => {
  const { t } = useTranslation();
  const { resolvedTheme, setTheme } = useTheme();

  const isDark = resolvedTheme === 'dark';

  const handleToggle = () => {
    const htmlElement = document.documentElement;
    htmlElement.classList.add('theme-transition');

    setTheme(isDark ? 'light' : 'dark');

    setTimeout(() => {
      htmlElement.classList.remove('theme-transition');
    }, 300);
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label={t('app.v11.nav.toggleTheme')}
      onClick={handleToggle}
      className={[
        'relative inline-flex h-7 w-14 shrink-0 cursor-pointer items-center rounded-full transition-colors duration-300 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-v11-accent focus-visible:ring-offset-2',
        isDark ? 'bg-zinc-800' : 'bg-[#DEDEDB]',
      ].join(' ')}
    >
      {/* Icon on the track (opposite side of the thumb) */}
      <span
        className={[
          'absolute flex items-center justify-center transition-opacity duration-300',
          isDark ? 'right-[7px] opacity-100' : 'right-[7px] opacity-0',
        ].join(' ')}
        aria-hidden="true"
      >
        <Moon className="h-[18px] w-[18px] text-zinc-400" strokeWidth={1.6} />
      </span>
      <span
        className={[
          'absolute flex items-center justify-center transition-opacity duration-300',
          isDark ? 'left-[7px] opacity-0' : 'left-[7px] opacity-100',
        ].join(' ')}
        aria-hidden="true"
      >
        <Sun className="h-[18px] w-[18px] text-v11-text-secondary" strokeWidth={1.6} />
      </span>

      {/* Sliding thumb */}
      <span
        className={[
          'pointer-events-none inline-block h-[21px] w-[21px] rounded-full ring-0 transition-transform duration-300',
          isDark ? 'translate-x-[3px] bg-white' : 'translate-x-[32px] bg-[#2019E4]',
        ].join(' ')}
      />
      <span className="sr-only">{t('app.v11.nav.toggleTheme')}</span>
    </button>
  );
};
